export enum Priority {
  Low = 'PRIORITY.LOW',
  Medium = 'PRIORITY.MEDIUM',
  High = 'PRIORITY.HIGH',
}
